var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'android-image-protection': _vm.isAndroid },attrs:{"id":"app"},on:{"contextmenu":_vm.preventAndroidImageMenu,"dragstart":_vm.preventAndroidImageMenu,"selectstart":_vm.preventAndroidImageMenu}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }